import React from 'react';
import { Form, Select, Typography } from 'antd';

const { Text } = Typography;
const { Option } = Select;

const MergeFlowNodeProperties = ({ config }) => {
  return (
    <>
      <Form.Item label="Merge Strategy" name="mergeStrategy" initialValue={config.mergeStrategy || 'union'} rules={[{ required: true }]}>
        <Select>
          <Option value="union">Union (Combine All Rows)</Option>
          <Option value="merge_objects">Merge by Row Index</Option>
          <Option value="first_only">First Input Only</Option>
          <Option value="last_only">Last Input Only</Option>
        </Select>
      </Form.Item>

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>Merge Flow Node:</strong><br/>
          • Combines data from multiple input branches<br/>
          • <strong>Union:</strong> Concatenates all rows from all inputs<br/>
          • <strong>Merge by Row Index:</strong> Combines row 1 + row 1, row 2 + row 2, etc.<br/>
          • Use after Range Branch or parallel processing paths
        </Text>
      </div>
    </>
  );
};

export default MergeFlowNodeProperties;